import { ValidationResult } from '../../types/helmetLookup'

export const validateHelmetId = (input: string): ValidationResult => {
  if (!input.trim()) {
    return { valid: false, type: null, format: null }
  }

  const rfidLabelPattern = /^(2[3-9]|3[0-5])-\d{4}$/
  const rfidCodePattern = /^[A-Za-z0-9]+$/
  
  if (rfidLabelPattern.test(input)) {
    return { valid: true, type: 'rfidLabel', format: 'RFID Label (YY-####)' }
  } else if (rfidCodePattern.test(input) && !input.includes('-')) {
    return { valid: true, type: 'rfidCode', format: 'RFID Code (Alphanumeric)' }
  } else {
    return { valid: false, type: null, format: null }
  }
}

export const isSFEchoHelmet = (helmetInfo: { features?: string | null }): boolean => {
  return helmetInfo.features?.toLowerCase() === 'sf-echo'
}

export const isConvertibleHelmet = (helmetInfo: { features?: string | null }): boolean => {
  return helmetInfo.features?.toLowerCase() === 'convertible'
}

export const createPlayerName = (helmetInfo: any): string => {
  if (!helmetInfo || !helmetInfo.firstName || !helmetInfo.lastName) {
    return 'Unassigned'
  }

  if (helmetInfo.firstName.toUpperCase() === 'RIDDELL') {
    return `${helmetInfo.firstName} ${helmetInfo.lastName}`
  }

  return `${helmetInfo.lastName}, ${helmetInfo.firstName}`
}
